import { motion } from 'framer-motion'
import clsx from 'clsx'
import { Icon } from 'components/ui/Icon'
import { useToggleWidget } from 'hooks/useToggleWidget'
import { useTranslation } from 'react-i18next'
import { useEffect, useMemo, useState } from 'react'
import ObjectID from 'bson-objectid'

export const WidgetHelpMessage = () => {
  const widgetHelpId = useMemo(() => String(ObjectID()), [])
  const isWidgetOpened = useToggleWidget()
  const { t } = useTranslation()
  const [showHelpMessage, setShowHelpMessage] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      if (!isWidgetOpened) {
        setShowHelpMessage(true)
      }
    }, 1500)
  }, [])

  useEffect(() => {
    if (isWidgetOpened && showHelpMessage) {
      setShowHelpMessage(false)
    }
  }, [isWidgetOpened])

  if (showHelpMessage) {
    return (
      <motion.div
        key={widgetHelpId}
        className={clsx(
          'tw-fixed tw-bottom-20 tw-right-4 tw-text-sm tw-border-primary-500 tw-border tw-p-2 tw-rounded-xl tw-bg-primary-500',
        )}
        initial={{ y: -80, opacity: 0 }} // Initial position and opacity
        animate={{ y: 0, opacity: 1, transition: { type: 'spring', stiffness: 80 } }} // Bounce animation configuration
      >
        <div style={{ zIndex: 999999, fontWeight: 700, color: 'white' }}>
          <span className={'tw-mr-[3px]'}>{t('needHelp')}</span>
          <Icon icon={['fas', 'question-circle']} style={{ fontSize: '14px' }} color={'white'} />
        </div>
      </motion.div>
    )
  }

  return null
}
